import { defineMessages } from 'react-intl';
import { EMAIL_REGEX } from 'constants/regexes';
import { isBlank } from 'helpers/verify';
import { passwordValidator } from 'validators/password';

export const PASSWORD_MIN_LENGTH = 6;

const messages = defineMessages({
  required: {
    id: 'signup.form.validations.genericRequired',
    defaultMessage: 'This information is required.',
  },
  invalidEmail: {
    id: 'signup.form.validations.invalidEmail',
    defaultMessage: 'Please enter a valid email.',
  },
});

export const baseSignupValidator = data => {
  const errors = {};

  if (isBlank(data.password)) {
    errors.password = messages.required;
  } else if (passwordValidator(data.password)) {
    errors.password = passwordValidator(data.password);
  }

  if (isBlank(data.firstName)) {
    errors.firstName = messages.required;
  }

  if (isBlank(data.lastName)) {
    errors.lastName = messages.required;
  }

  if (isBlank(data.email)) {
    errors.email = messages.required;
  } else if (!EMAIL_REGEX.test(data.email)) {
    errors.email = messages.invalidEmail;
  }

  return errors;
};
